<template>
  <div style="min-width: 1500px">
    <div style="height: 100px"></div>
    <!-- bannner -->
    <div class="animate__animated animate__backInDown">
      <!-- <Carousel v-model="value1" loop autoplay :autoplay-speed="4000">
        <CarouselItem v-for="(item, index) in imgList" :key="index">
          <img style="width: 100%; hieght: 100%" :src="item" alt="" />
        </CarouselItem>
      </Carousel> -->

      <el-carousel height="850px" autoplay :interval="4000">
        <el-carousel-item v-for="(item, index) in imgList" :key="index">
          <img style="width: 100%; hieght: 100%" :src="item" alt="" />
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="main">
      <!-- 公司简介 -->
      <transition name="fade">
        <div class="set-comp-box animate__animated animate__backInDown">
          <div class="common">
            <div class="set-title">
              <img src="../assets/img/introduce.png" alt />
            </div>
            <div class="set-cont">
              <div class="introduction-cont">
                <div class="introduction-cont-left">
                  <img src="../assets/img/introduce-img.jpg" alt />
                </div>
                <div class="introduction-cont-right">
                  <p>
                    重庆中讯亚太信息技术有限公司成立于2001年，总部位于重庆市南岸区中讯•时代大厦，注册资本3000万。是重庆中讯控股(集团)有限公司旗下的专业从事计算机信息系统集成服务、信息安全服务、运维服务及综合软件研发的高科技企业。公司以“科技开发”与“成熟成果短期产业化”并行的发展模式，在教育、政府、医疗、企业等行业领域形成了较强的技术实力和市场竞争优势，取得了良好的经营业绩。公司拥有国家保密局颁发的涉及国家秘密的计算机信息系统集成乙级资质、电子与智能化工程专业承包贰级资质、ITSS信息技术服务运行维护资质、信息安全服务资质，多次荣获“重庆市优秀系统集成企业”、“守合同重信用单位”、“优秀纳税人”等荣誉称号，并被认定为重庆市“高新技术企业”及“软件企业”。
                    <br />
                  </p>
                  <p style="margin-top: 0px">
                    经过近二十年的发展，先后控股了东方中讯、中讯亚太科技、北京比尼、四川中讯亚迪四家子公司，成为年营业收入过亿的高科技公司。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <!-- 资质荣誉 -->
      <div class="set-hnor-box animate__animated animate__backInDown">
        <div class="common">
          <div class="set-title">
            <img src="../assets/img/hnor.png" alt />
          </div>
          <div class="set-hnor-cont">
            <div class="set-hnor-cont-title">
              <ul>
                <li
                  :class="[isActive == 1 ? 'active' : '']"
                  @click="handleChangeType(1)"
                >
                  企业资质
                </li>
                <li
                  :class="[isActive == 2 ? 'active' : '']"
                  @click="handleChangeType(2)"
                >
                  企业荣誉
                </li>
              </ul>
            </div>

            <!-- 资质荣誉的轮播 -->
            <div style="width: 80%; margin: auto" v-if="isActive == 1">
              <swiper class="swiper-container swiper-container222" :options="swiperOption"  ref="mySwiper" v-if="honorList.length" >
                <swiper-slide v-for="(item, index) in honorList.slice(0, 8)" :key="index" >
                  <img :src="item.img" alt="" style="width: 100%" srcset="" />
                  <p>{{ item.title }}</p>
                </swiper-slide>
              </swiper>
            </div>
            <!-- 资质荣誉的轮播 -->
            <div
              style="width: 80%; margin: auto; margin-top: 30px"
              v-if="isActive == 2"
            >
              <swiper
                class="swiper-container swiper-container222"
                :options="swiperOption"
                ref="mySwiper"
                v-if="honorList2.length"
              >
                <swiper-slide
                  v-for="(item, index) in honorList2.slice(0, 8)"
                  :key="index"
                >
                  <img :src="item.img" alt="" style="width: 100%" srcset="" />
                  <p>{{ item.title }}</p>
                </swiper-slide>
              </swiper>
            </div>
          </div>
        </div>
      </div>
      <!-- 亚太服务 -->
      <div class="set-service-box animate__animated animate__backInDown">
        <div class="common">
          <div class="set-title">
            <img src="../assets/img/service.png" alt />
          </div>
          <div class="set-service-cont">
            <div
              class="set-service-item"
              @click="handleTo('/service', 0, null, 1)"
            >
              <div>
                <img src="../assets/img/service-img.png" alt />
                <div class="set-service-item-cont">集成系统服务</div>
              </div>
            </div>
            <div
              class="set-service-item"
              @click="handleTo('/service', 1, null, 1)"
            >
              <div>
                <img src="../assets/img/computer.png" alt />
                <div class="set-service-item-cont">运维服务</div>
              </div>
            </div>
            <div
              class="set-service-item"
              @click="handleTo('/service', 2, null, 1)"
            >
              <div>
                <img src="../assets/img/ele.png" style="width: 100%" alt />
                <div class="set-service-item-cont">电子认证服务</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 新闻动态 -->
      <div class="set-news-box animate__animated animate__backInDown">
        <div class="common">
          <div class="set-title">
            <img src="../assets/img/news.png" alt />
          </div>
          <div class="set-news-cont">
            <div
              class="set-news-cont-left"
              @click="handleTo('/about', 4, newInfo[0].id)"
            >
              <img :src="newInfo[0].reserved" alt />
              <h4 style="line-height: 40px; margin-top: 10px; font-size: 24px">
                {{ newInfo[0].title }}
              </h4>
              <div class="set-news-cont-left-data">
                <div class="set-news-cont-left-data-left">
                  <div class="set-news-cont-left-data-left-year">
                    {{ newInfo[0].gmtCreate.split(" ")[0] }}
                  </div>
                  <!-- <div class="set-news-cont-left-data-left-mon">
                    {{ newInfo[0].gmtCreate.split(" ")[1] }}
                  </div> -->
                </div>
                <div class="set-news-cont-left-data-right">
                  {{ newInfo[0].reservedExtend }}
                </div>
              </div>
            </div>
            <div class="set-news-cont-right">
              <div
                class="set-news-cont-left-data set-right-border"
                v-for="(item, index) in newInfo2"
                @click="handleTo('/about', 4, item.id)"
              >
                <div class="set-news-cont-left-data-left">
                  <div class="set-news-cont-left-data-left-year">
                    {{ item.gmtCreate.split("-")[0] }}
                  </div>
                  <div class="set-news-cont-left-data-left-mon">
                    {{ item.gmtCreate.split("-")[1] }}-
                    {{ item.gmtCreate.split("-")[2].split(" ")[0] }}
                  </div>
                </div>
                <div>
                  <div class="set-news-cont-right-data-title">
                    {{ item.title }}
                  </div>
                  <div class="set-news-cont-right-data-right">
                    {{ item.reservedExtend }}
                  </div>
                </div>
              </div>

              <div class="more-btn" @click="handleTo('/about', 1)">
                <img src="../assets/img/showmore.png" alt />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import img from "../assets/image/img1.jpg";
import img2 from "../assets/image/img2.jpg";
import img3 from "../assets/image/img3.jpg";
import { getNewsInfo, getHonorInfo } from "../api";
export default {
  data() {
    return {
      value1: 0,
      isActive: 1,
      show: true,
      imgList: [img, img2, img3],
      newInfo: [{ title: "", gmtCreate: "2010-10-09 12:30:21" }],
      newInfo2: [{ title: "", gmtCreate: "2010-10-09 12:30:21" }],
      honorList: [],
      honorList2: [],
      curPage: 1,
      pageTotal: null,
      swiperOption: {
        slidesPerView: 4,
        spaceBetween: 20,
        loop: true,
        loopedSlides: 5,
        loopAdditionalSlides: 1,
        autoplayDisableOnInteraction: true,
        // observeParents: false, //必须加入
        // observer: true, //必须加入
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      },
    };
  },
  components: {
    swiper,
    swiperSlide,
  },
  watch: {
    //通过props传来的数据 和 组件一加载节点就创建成功 二者不是同步，实时监听的swiper(传递的值)的变化
    // swiper() {
    //   this.swiperUpdate();
    // },
  },
  methods: {
    handleChangeType(num) {
      this.isActive = num;
      this.curPage = 1;
      this.handleChoose(num);
    },
    async handleChoose(num) {
      if (num == 1) {
        let res = await getHonorInfo({
          type: num,
          limit: 100,
          isPage: 1,
          curPage: this.curPage,
        });
        this.honorList = res.data.data;
        this.pageTotal = res.data.pageTotal;
      }
      if (num == 2) {
        let res = await getHonorInfo({
          type: num,
          limit: 100,
          isPage: 1,
          curPage: this.curPage,
        });
        this.honorList2 = res.data.data;
        this.pageTotal = res.data.pageTotal;
      }
    },
    handleClick: function () {
      this.show = !this.show;
    },
    handleToTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    handleTo(path, activeNo = 0, id = 0, isActive = 1) {
      this.$router.push({
        path,
        query: {
          activeNo,
          id,
          isActive,
        },
      });
    },
  },
  async mounted() {
    let res = await getNewsInfo({
      isPage: 1,
      curPage: 1,
      limit: 4,
    });
    this.newInfo = res.data.data;
    this.newInfo2 = JSON.parse(JSON.stringify(this.newInfo));
    this.newInfo2.shift();
    let res2 = await getHonorInfo({
      type: 1,
      limit: 10000,
      isPage: 1,
      curPage: this.curPage,
    });
    this.honorList = res2.data.data;
    this.pageTotal = res2.data.pageTotal;
    this.handleToTop();

    // this.swiperUpdate(); //页面一加载拉去数据创建节点
  },
  computed: {
    // swiper() {
    //   return this.$refs.mySwiper.swiper;
    // },
  },
};
</script>

<style >
/* .swiper-container222 .swiper-wrapper {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
} */
.swiper-container222 .swiper-slide {
  margin: auto !important;
  margin-right: 20px !important;
}
.demo-carousel {
  width: 100%;
  height: 960px;
  background-color: #ccc;
}
.main {
  padding-bottom: 50px;
}
.set-comp-box {
  height: 800px;
  background-color: #f0f0f0;
  padding-top: 10px;
  width: 100%;
}
.set-title {
  width: 280px;
  margin: auto;
  margin-top: 20px;
}
.set-title img {
  width: 100%;
}
.set-title-info {
  font-size: 60px;
  color: aquamarine;
}
.set-cont {
  margin-top: 10px;
  position: relative;
}
.set-cont-left {
  width: 1500px;
  background: url("../assets/img/building.jpg");
  background-size: cover;
  padding: 50px 370px 40px 30px;
  color: #fff;
  height: 540px;
  font-size: 20px;
}
.set-cont-left p {
  text-indent: 3rem;
  line-height: 30px;
  font-size: 20px;
  text-align: left;
}
.set-cont-right {
  position: absolute;
  right: 0;
  bottom: 30px;
  width: 680px;
  height: 400px;
}
.set-hnor-cont {
  margin-bottom: 30px;
}
.set-cont-right img {
  width: 100%;
  height: 100%;
}
.set-hnor-box {
  height: 750px;
}
.set-hnor-cont-title {
  width: 310px;
  margin: auto;
  padding-bottom: 60px;
  margin-bottom: 30px;
}
.set-hnor-cont-title ul {
  margin-top: 80px;
  margin-bottom: 80px;
}
.set-hnor-cont-title ul li {
  width: 120px;
  height: 60px;
  font-size: 30px;
  line-height: 60px;
  cursor: pointer;
}
.set-hnor-cont-title ul li:nth-child(1) {
  float: left;
}
.set-hnor-cont-title ul li:nth-child(2) {
  float: right;
}
.set-hnor-cont-title ul li.active {
  color: #4774b6;
  border-bottom: 4px solid #4774b6;
}
.el-carousel__item {
  background-color: #fff !important;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.set-service-box {
  background-color: #f0f0f0;
  height: 600px;
  padding-top: 20px;
}
.set-service-cont {
  display: flex;
  justify-content: space-around;
  padding-top: 30px;
}
.set-service-item {
  margin-top: 30px;
  width: 430px;
  height: 450px;
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
}
.set-service-item img {
  width: 430px;
  /* height: 300px; */
}
.set-service-item-cont {
  font-size: 25px;
  margin-top: 10px;
  line-height: 72px;
  font-weight: 800;
}
.set-news-box {
  min-height: 940px;
  padding-top: 20px;
}
.set-news-cont-left {
  margin-top: 40px;
  width: 900px;
  /* height: 450px; */
  float: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
}
.set-news-cont-left img {
  /* width: 900px;
  height: 300px; */
  width: 100%;
  /* width: 560px;
  height: 328px; */
}
.set-news-cont-left-data {
  display: flex;
  /* align-items: flex-start; */
  justify-content: flex-start;
  text-align: left;
}
.set-news-cont-left-data-left {
  margin-right: 10px;
  width: 320px;
}
.set-news-cont-left-data-left-year {
  font-size: 20px;
  line-height: 60px;
  font-weight: 800;
}
.set-news-cont-left-data-right {
  font-size: 16px;
  line-height: 36px;
  width: 100%;
  word-break: break-all;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.set-news-cont-right {
  margin-top: 40px;
  float: right;
  width: 500px;
  height: 450px;
}
.set-news-cont-right-data-title {
  line-height: 40px;
  font-size: 20px;
  line-height: 60px;
}
.set-news-cont-right-data-right {
  font-size: 18px;
  overflow: hidden;
  width: 400px;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.set-news-cont-left-data-left-mon {
  color: #888888;
  font-size: 16px;
}
.set-right-border {
  border: 2px dashed #c4c4c4;
  border-left: none;
  border-right: none;
  padding: 20px 0px 20px 10px;
}
.set-right-border:nth-child(2),
.set-right-border:nth-child(3) {
  border-bottom: none;
}
.more-btn {
  margin-top: 30px;
}
.more-btn img {
  width: 188px;
  height: 46px;
}
.medium {
  font-size: 16px !important;
  line-height: 24px;
  background-color: #fff;
  text-align: center;
  text-overflow: -o-ellipsis-lastline;
  width: 80% !important;
  margin: auto !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-top: 30px;
}

@media screen and (max-width: 1500px) {
  .set-comp-box {
    height: 780px;
    width: 100%;
  }
  .set-cont-left {
    width: 1500px;
    background-color: #4774b6;
    padding: 50px 370px 20px 30px;
    color: #fff;
    height: 520px;
    font-size: 14px;
  }
  .set-cont-left p {
    text-indent: 2rem;
    line-height: 30px;
    text-align: left;
  }
  .set-cont-right {
    position: absolute;
    right: 0;
    bottom: 130px;
    width: 460px;
    height: 280px;
  }

  .set-service-item {
    width: 330px;
  }
  .set-service-item img {
    width: 100%;
  }
  .set-news-cont-left {
    margin-top: 40px;
    width: 560px;
    height: 450px;
  }
  .set-news-cont-left img {
    width: 560px;
    height: 240px;
  }
  .set-news-cont-right {
    margin-top: 40px;
    float: right;
    width: 320px;
    height: 450px;
  }
  .set-news-cont-right-data-right {
    font-size: 16px;
    width: 200px;
  }
}
</style>